<template>
    <div class="imageclip-box">
        <div class="clip-box">
            <vueCropper ref="cropper2" :img="this.imgDataUrl" :outputSize="example2.size" :outputType="example2.outputType"
                :info="example2.info" :canScale="example2.canScale" :autoCrop="example2.autoCrop"
                :autoCropWidth="example2.autoCropWidth" :autoCropHeight="example2.autoCropHeight"
                :fixed="example2.fixed" :fixedNumber="example2.fixedNumber" :enlarge="4"></vueCropper>
        </div>
        <button class="btn" @click='clip'>裁剪</button>
    </div>
</template>
<script>
    export default {
        name: 'ImageClip',
        props: {
            imgDataUrl: String
        },
        data() {
            return {
                model: false,
                modelSrc: '',
                crap: false,
                previews: {},
                form: {
                    head: ''
                },
                example2: {
                    //img的路径自行修改
                    info: true,
                    size: 1,
                    outputType: 'jpeg',
                    canScale: true,
                    autoCrop: true,
                    // 只有自动截图开启 宽度高度才生效
                    autoCropWidth: 400,
                    autoCropHeight: 400,
                    fixed: true,
                    // 真实的输出宽高
                    infoTrue: true,
                    fixedNumber: [1, 1]
                },
                downImg: '#'
            }
        },
        methods: {
            clip() {
                let _this=this
                this.$refs.cropper2.getCropData(data => {
                    // console.log(data)
                    _this.$emit('imgSaveToFile',data)
                })
            }
        }
    }
</script>
<style scoped>
    .clip-box {
        height: 500px;
    }

    .btn {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #fff;
        border: 1px solid #c0ccda;
        color: #1f2d3d;
        text-align: center;
        box-sizing: border-box;
        outline: none;
        margin: 20px 10px 0px 0px;
        padding: 9px 15px;
        font-size: 14px;
        border-radius: 4px;
        color: #fff;
        background-color: #50bfff;
        border-color: #50bfff;
        transition: all .2s ease;
        text-decoration: none;
        user-select: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/admin/imageClip.vue